// extracted by mini-css-extract-plugin
export var activeTab = "ConfirmDetails-module--activeTab--AucJI";
export var container = "ConfirmDetails-module--container--vXhAU";
export var items = "ConfirmDetails-module--items--51odc";
export var itemsSubTitle = "ConfirmDetails-module--itemsSubTitle--D3wVN";
export var itemsTitle = "ConfirmDetails-module--itemsTitle--yao3r";
export var open = "ConfirmDetails-module--open--13sgO";
export var productSelect = "ConfirmDetails-module--productSelect--CkgAB";
export var productSelectContainer = "ConfirmDetails-module--productSelectContainer--qsO31";
export var tabs = "ConfirmDetails-module--tabs--QEekA";